import React from 'react';
import './Hero.css';
import starIcon from '../assets/images/star-icon.png';
import heroImage from '../assets/images/hero-image.png';
import backgroundPattern from '../assets/images/background-pattern.png';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-background">
        {/* Background pattern */}
        <div className="hero-pattern">
          <img src={backgroundPattern} alt="" className="pattern-bg" />
        </div>
        
        {/* Background ellipses */}
        <div className="hero-ellipses">
          <div className="ellipse ellipse-green"></div>
          <div className="ellipse ellipse-blue"></div>
          <div className="ellipse ellipse-purple"></div>
        </div>
        
        {/* Floating stars */}
        <div className="hero-stars">
          <img 
            src={starIcon} 
            alt="" 
            className="star star-1"
            loading="lazy"
            aria-hidden="true"
          />
          <img 
            src={starIcon} 
            alt="" 
            className="star star-2"
            loading="lazy"
            aria-hidden="true"
          />
          <img 
            src={starIcon} 
            alt="" 
            className="star star-3"
            loading="lazy"
            aria-hidden="true"
          />
        </div>
      </div>
      
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              Shop Iconic Luxury <br />
              <span className='primary-color'>with $FLOW</span>
            </h1>
            <p className="hero-subtitle">
              Power your style with blockchain. Buy authenticated high-end products 
              using your FLOW tokens — securely, instantly, and globally.
            </p>
            <div className="hero-buttons">
              <a href="#learn" className="btn btn-secondary">Learn More</a>
              <a href="#access" className="btn btn-outline">
                Get Access
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M1.67 10H16.67M10 3.33L16.67 10L10 16.67" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>
            </div>
          </div>
          
          <div className="hero-image">
            <img 
              src={heroImage} 
              alt="Luxury marketplace interface" 
              className="main-hero-image"
              loading="eager"
            />
            <div className="hero-image-decoration">
              <img 
                src={starIcon} 
                alt="" 
                className="decoration-star"
                aria-hidden="true"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
